// extracted by mini-css-extract-plugin
export default {"labResultCareComponent":"LabResultCareComponent_labResultCareComponent__vlKUO","analysis":"LabResultCareComponent_analysis__uP1Nh","unit":"LabResultCareComponent_unit__RJm7g"};